import React, { useEffect } from "react";
import "./MoreAbout.css";
import "@fontsource/source-sans-pro";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import MainBanner from "./components/MainBanner/MainBanner";
import img from "./assets/images/img.webp";
import Banner from "./components/Banner/Banner";
import { Helmet } from "react-helmet-async";

const MoreAbout = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          More About ISKCON – Krishna Consciousness Movement Origins & Vision
        </title>
        <meta
          name="description"
          content="Explore the deeper roots of ISKCON, its global impact, the teachings of Srila Prabhupada, and the spiritual purpose behind this Krishna consciousness movement."
        />
        <meta
          name="keywords"
          content="about ISKCON, Krishna consciousness movement, Srila Prabhupada teachings, ISKCON vision"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="More About ISKCON – Krishna Consciousness Movement Origins & Vision"
        />
        <meta
          property="og:description"
          content="Explore the deeper roots of ISKCON, its global impact, the teachings of Srila Prabhupada, and the spiritual purpose behind this Krishna consciousness movement."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/more-about-iskcon"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="More About ISKCON – Krishna Consciousness Movement Origins & Vision"
        />
        <meta
          name="twitter:description"
          content="Explore the deeper roots of ISKCON, its global impact, the teachings of Srila Prabhupada, and the spiritual purpose behind this Krishna consciousness movement."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/more-about-iskcon"
        />
      </Helmet>

      <Header />
      <div className="more-about-page">
        <MainBanner />
        <div className="d-flex justify-content-center more-about-img">
          <div className="text-center">
            <img
              loading="lazy"
              src={img}
              alt="Founder"
              className="more-about"
            />
          </div>
        </div>
        <Banner />
      </div>
      <Footer />
    </>
  );
};

export default MoreAbout;
